import { ConfigService } from "../config.service";

export class ImageHelpers {

  static getImageURL(path: string, filename: string, config: ConfigService, baseFolder: string = 'pos') {
    
    let imageUrl = `${window.location.origin}/assets/`;

    try {
      if (config.assetsSettings.address && config.assetsSettings.address.indexOf('http') === 0) {
        imageUrl = `${config.assetsSettings.address}/assets/`;
      }
    } catch (error) {
      
    }

    switch (path) {
      case 'info-dialog':
        const gloryMatch = filename.match(/(rbw100|rcw100|rz50).*.gif/gi);

        if (gloryMatch && gloryMatch[0]) { 
          path = 'glory';
          filename = gloryMatch[0];
        }
        break;
    }

    if (path && filename && config) {
      try {
        if (filename.indexOf('http') === -1 || filename.substr(-4).toLowerCase() === '.gif') {
          // got partial path
          imageUrl += `${baseFolder}/${path}/${filename}`;
          return imageUrl;
        } else {
          // is a image full path
          return filename;
        }
      } catch (error) {
        return '#';
      }
    } else {
      return '#';
    }
  }

}